import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-nutzungsbedingungen',
    standalone: true,
    imports: [CommonModule, MarkdownModule],
    templateUrl: './nutzungsbedingungen.component.html',
    styleUrls: ['./nutzungsbedingungen.component.css']
})
export class NutzungsbedingungenComponent { }